// blocks
// Regular blocks being used in content creation
import Bonus from "$lib/admin/components/blocks/blocks/Bonus.svelte";
import ButtonLink from "$lib/admin/components/blocks/blocks/ButtonLink.svelte";
import Cards from "$lib/admin/components/blocks/blocks/Cards.svelte";
import Columns from "$lib/admin/components/blocks/blocks/Columns.svelte";
import Content from "$lib/admin/components/blocks/blocks/Content/index.svelte";
import DataTable from "$lib/admin/components/blocks/blocks/DataTable/DataTable.svelte";
import FAQ from "$lib/admin/components/blocks/blocks/FAQ.svelte";
import HighlightedCasino from "$lib/admin/components/blocks/blocks/HighlightedCasino/index.svelte";
import TournamentCard from "$lib/admin/components/blocks/blocks/Tournaments/TournamentCard.svelte";
import Image from "$lib/admin/components/blocks/blocks/Images/index.svelte";
import FocusPanel from "$lib/admin/components/blocks/blocks/FocusPanel.svelte";
import Links from "$lib/admin/components/blocks/blocks/Links.svelte";
import List from "$lib/admin/components/blocks/blocks/List/index.svelte";
import PostList from "$lib/admin/components/blocks/blocks/PostList.svelte";
import Separator from "$lib/admin/components/blocks/blocks/Separator.svelte";
import Table from "$lib/admin/components/blocks/blocks/Table.svelte";
import TableFacts from "$lib/admin/components/blocks/blocks/TableFacts.svelte";
import TabbedTable from "$lib/admin/components/blocks/blocks/TabbedTable.svelte";
import Toplist from "$lib/admin/components/blocks/blocks/Toplist.svelte";
import Video from "$lib/admin/components/blocks/blocks/Video.svelte";
import Experience from "$lib/admin/components/blocks/blocks/Experience/Experience.svelte";
import Feedback from "$lib/admin/components/blocks/blocks/Feedback.svelte";
import RatingsAndSummary from "$lib/admin/components/blocks/blocks/Ratings/Ratings.svelte";
import RecentChanges from "$lib/admin/components/blocks/blocks/RecentChanges.svelte";
import TopListEntry from "$lib/admin/components/blocks/blocks/TopListEntry.svelte";
import FactsBox from "$lib/admin/components/blocks/blocks/FactsBox.svelte";
import Banners from "$lib/admin/components/blocks/blocks/Banners/index.svelte";
import TournamentToplist from "$lib/admin/components/blocks/blocks/Tournaments/TournamentToplist/index.svelte";

// meta
// Mostly helper blocks that are used to accompany user-generated components
import ArticleAd from "$lib/admin/components/blocks/helpers/ArticleAd.svelte";
import LastUpdated from "$lib/admin/components/blocks/helpers/LastUpdated.svelte";
import Placeholder from "$lib/admin/components/blocks/helpers/Placeholder.svelte";

// helpers
// Blocks that are not used directly, but rather indirectly in other blocks
// we do not need to import these; if we do, then they are not exclusively helpers and should be put into another section

// sections
// Blocks that are considered separate from content or are whole sections of content
import FixedData from "$lib/admin/components/blocks/sections/FixedData.svelte";
import FocusPanelContent from "$lib/admin/components/blocks/sections/FocusPanelContent.svelte";
import Intro from "$lib/admin/components/blocks/sections/Intro/index.svelte";
import IntroLinks from "$lib/admin/components/blocks/sections/IntroLinks.svelte";
import IntroReview from "$lib/admin/components/blocks/sections/IntroReview.svelte";
import LotteryResults from "$lib/admin/components/blocks/sections/LotteryResults.svelte";
import StepByStep from "$lib/admin/components/blocks/sections/StepByStep.svelte";
import StreamTable from "$lib/admin/components/blocks/sections/StreamTable.svelte";
import WriterMeta from "$lib/admin/components/blocks/blocks/WriterMeta/index.svelte";
import PageInsights from "$lib/admin/components/blocks/sections/PageInsights/index.svelte";

// tournaments
import UserStatistics from "$lib/admin/components/blocks/blocks/Tournaments/UserStatistics.svelte";
import Winners from "$lib/admin/components/blocks/blocks/Tournaments/Winners.svelte";
import AboutTournamentProvider from "$lib/admin/components/blocks/blocks/Tournaments/AboutTournamentProvider.svelte";

const imports = {
  /* BLOCKS */
  Bonus: { cls: Bonus, folder: "Blocks", extraOptions: ["Styling Options"] },
  ButtonLink: { cls: ButtonLink, folder: "Blocks", extraOptions: ["Styling Options"] },
  Cards: { cls: Cards, folder: "Blocks", extraOptions: ["Styling Options"] },
  Columns: { cls: Columns, folder: "Blocks", extraOptions: ["Styling Options"] },
  Content: { cls: Content, folder: "Blocks", extraOptions: ["Add to TOC", "Styling Options"] },
  FAQ: {
    cls: FAQ,
    folder: "Blocks",
    extraOptions: ["Heading", "Section Styling", "Add to TOC", "Styling Options"],
  },
  FocusPanel: {
    cls: FocusPanel,
    folder: "Blocks",
    extraOptions: ["Add to TOC", "Styling Options"],
  },
  HighlightedCasino: { cls: HighlightedCasino, folder: "Blocks", extraOptions: ["Styling Options"] },
  Image: { cls: Image, folder: "Blocks", extraOptions: ["Add to TOC", "Styling Options"] },
  Links: { cls: Links, folder: "Blocks", extraOptions: ["Styling Options"] },
  List: {
    cls: List,
    folder: "Blocks",
    extraOptions: ["Heading", "Add to TOC", "Styling Options"],
  },
  PostList: {
    cls: PostList,
    folder: "Blocks",
    extraOptions: ["Heading", "Read More Link", "Add Pagination", "Section Styling", "Add to TOC", "Styling Options"],
  },
  Separator: { cls: Separator, folder: "Blocks", extraOptions: ["Styling Options"] },
  TabbedTable: { cls: TabbedTable, folder: "Blocks", extraOptions: ["Styling Options"] },
  Table: {
    cls: Table,
    folder: "Blocks",
    extraOptions: ["Heading", "Add to TOC", "Styling Options"],
  },
  TableFacts: {
    cls: TableFacts,
    folder: "Blocks",
    extraOptions: ["Add to TOC", "Styling Options"],
  },
  Banners: {
    cls: Banners,
    folder: "Blocks",
    extraOptions: ["Heading", "Add to TOC", "Styling Options"],
  },
  Toplist: {
    cls: Toplist,
    folder: "Blocks",
    extraOptions: [
      "Heading",
      "Toplist Navigation Bar",
      "Toplist Load More",
      "Toplist Link Button",
      "Toplist Button",
      "Add to TOC",
      "Toplist Fixed Content",
      "Styling Options",
    ],
  },
  Video: { cls: Video, folder: "Blocks", extraOptions: ["Styling Options"] },
  Experience: { cls: Experience, folder: "Blocks", extraOptions: ["Styling Options"] },
  "Ratings + Summary": { cls: RatingsAndSummary, folder: "Blocks", extraOptions: ["Styling Options"] },
  Feedback: { cls: Feedback, folder: "Blocks", extraOptions: ["Styling Options"] },
  RecentChanges: { cls: RecentChanges, folder: "Blocks", extraOptions: ["Styling Options"] },
  TopListEntry: { cls: TopListEntry, folder: "Blocks", extraOptions: ["Styling Options"] },
  FactsBox: { cls: FactsBox, folder: "Blocks", extraOptions: ["Styling Options"] },

  ArticleAd: { cls: ArticleAd, folder: "Meta", extraOptions: ["Styling Options"] },
  LastUpdated: { cls: LastUpdated, folder: "Meta", extraOptions: ["Styling Options"] },
  Placeholder: { cls: Placeholder, folder: "Meta", extraOptions: ["Styling Options"] },

  /* SECTIONS */
  FixedData: { cls: FixedData, folder: "Sections", extraOptions: ["Heading", "Styling Options"] },
  FocusPanelContent: { cls: FocusPanelContent, folder: "Sections", extraOptions: ["Add to TOC", "Styling Options"] },
  Intro: {
    cls: Intro,
    folder: "Sections",
    extraOptions: ["Hide TOC", "Add to TOC"],
  },
  IntroLinks: { cls: IntroLinks, folder: "Sections", extraOptions: ["Styling Options"] },
  IntroReview: {
    cls: IntroReview,
    folder: "Sections",
    extraOptions: ["Hide TOC", "Add to TOC", "Styling Options"],
  },
  LotteryResults: {
    cls: LotteryResults,
    folder: "Sections",
    extraOptions: ["Heading", "Read More Link", "Add to TOC", "Styling Options"],
  },
  StepByStep: {
    cls: StepByStep,
    folder: "Sections",
    extraOptions: ["Heading", "CTA Link", "Add to TOC", "Styling Options"],
  },
  StreamTable: {
    cls: StreamTable,
    folder: "Sections",
    extraOptions: ["Heading", "Styling Options"],
  },
  WriterMeta: {
    cls: WriterMeta,
    folder: "Sections",
    extraOptions: ["Writer Title", "Styling Options"],
  },
  PageInsights: {
    cls: PageInsights,
    folder: "Sections",
    extraOptions: ["Hide TOC", "Add to TOC"],
  },

  /* Tournaments */
  Winners: { cls: Winners, folder: "Tournaments", extraOptions: ["Styling Options"] },
  UserStatistics: { cls: UserStatistics, folder: "Tournaments", extraOptions: ["Styling Options"] },
  TournamentCard: { cls: TournamentCard, folder: "Tournaments", extraOptions: ["Styling Options"] },
  AboutTournamentProvider: { cls: AboutTournamentProvider, folder: "Tournaments", extraOptions: ["Styling Options"] },
  DataTable: { cls: DataTable, folder: "Tournaments", extraOptions: ["Styling Options"] },
  TournamentToplist: { cls: TournamentToplist, folder: "Tournaments" },
};

export default imports;
